<div class="navbar sticky-top">
    <img src="assets/logo.svg" alt="logo" class="logo">
    <div class="routes">
        <ng-container *ngIf="authService.authState$ | async">
            <a routerLink="events" routerLinkActive="active" ><div class="link">Events</div></a>
            <a routerLink="themes" routerLinkActive="active" ><div class="link">Themes</div></a>
            <a routerLink="items" routerLinkActive="active" ><div class="link">Items</div></a>
            <a routerLink="own-items" routerLinkActive="active" ><div class="link">Own items</div></a>
            <div (click)="authService.logout()" class="link logout">Logout</div>
        </ng-container>
    </div>
</div>
